const TOUR_STORAGE_PREFIX = "aq_esource_form_studio_tour_v1";

export function getEsourceFormStudioTourStorageKey(staffId) {
  const id = String(staffId || "").trim();
  return id ? `${TOUR_STORAGE_PREFIX}_${id}` : TOUR_STORAGE_PREFIX;
}

export function hasCompletedEsourceFormStudioTour(staffId) {
  try {
    return (
      localStorage.getItem(getEsourceFormStudioTourStorageKey(staffId)) === "1"
    );
  } catch {
    return false;
  }
}

export function markEsourceFormStudioTourCompleted(staffId) {
  try {
    localStorage.setItem(getEsourceFormStudioTourStorageKey(staffId), "1");
  } catch {
    /* ignore quota errors */
  }
}
